import tw from 'twin.macro'
import { useState } from 'react'
import { graphql, navigate, useStaticQuery } from 'gatsby'
// import { useTranslation } from '@/utils/useTranslation'
import { useLocation } from '@reach/router'
import { getBrowserLocaleBestMatch, localizedPath, useLocale } from '@plugins/bw-i18next'
import CtaLink from './ui/cta-link'

export default function SelectLocale({ otherLocales = [] }): JSX.Element {
  // const { t } = useTranslation()
  const { pathname } = useLocation()
  const { currentLocale } = useLocale()
  const bestMatch = getBrowserLocaleBestMatch()
  const [isMessageVisible, setIsMessageVisible] = useState(false)
  const messagesLocales = {
    'en-us': 'This site is available in English.',
    'de-de': 'Diese Website ist auf Deutsch verfügbar.',
    'ja-jp': 'このサイトは日本語でご利用いただけます。',
  }

  const {
    allContentfulLocales: {
      nodes: [{ locales }],
    },
  } = useStaticQuery(graphql`
    query AllContentfulLocales {
      allContentfulLocales {
        nodes {
          locales {
            slug
            label
          }
        }
      }
    }
  `)

  // in the future we may want this message back
  // useEffect(() => {
  //   if (currentLocale === bestMatch) return
  //   setTimeout(() => setIsMessageVisible(true), 3000)
  // }, [])

  return (
    <div>
      <div
        tw="text-xl fixed bottom-8 right-8 p-6 bg-gray-200 rounded-4xl shadow-2xl transition-all"
        css={[isMessageVisible ? tw`scale-100 opacity-100` : tw`scale-0 opacity-0`]}
      >
        {messagesLocales[bestMatch]}{' '}
        <div tw="pt-2">
          <CtaLink
            to={otherLocales?.find((locale) => locale.slug === bestMatch)?.path || localizedPath(pathname, bestMatch)}
            variant="Button: Solid"
            tw="mr-2 text-white!"
          >
            Go to English
          </CtaLink>
          <CtaLink to="#" onClick={() => setIsMessageVisible(false)}>
            Stay Here
          </CtaLink>
        </div>
      </div>

      {/* <label htmlFor="footer-language" tw="">
        {t('Language')}
      </label> */}
      <div tw="relative">
        <select
          tw="w-auto h-10 pl-4 pr-8 bg-transparent border border-gray-200 rounded-4xl appearance-none outline-transparent
            focus-visible:outline-none focus-visible:border focus-visible:(border-primaryBlue shadow-[0_0_0_1px] shadow-primaryBlue) cursor-pointer hover:(bg-gray-100 border-gray-300) dark:(hover:bg-transparent)"
          id="footer-language"
          defaultValue={currentLocale}
          onChange={(event) => {
            const slug = event.target.value
            const newPath = otherLocales.find((other) => other.includes(slug)) || otherLocales[0] || pathname || '/'
            if (window.Osano && window.Osano.cm) {
              window.Osano.cm.locale = slug.substring(0, 2)
            }
            navigate(localizedPath(newPath, slug))
          }}
        >
          {locales.map((locale) => (
            <option key={locale.slug} value={locale.slug} style={{ backgroundColor: 'indigoBlue' }}>
              {locale.label}
            </option>
          ))}
        </select>
        <span tw="font-bwi block absolute top-0 right-4 pointer-events-none text-[0.625rem] leading-[2.5rem]">
          &#xe92d;
        </span>
      </div>
    </div>
  )
}
